// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3hrK5","gfeWrapper":"CalendarEvent_gfeWrapper__3Rylb"};